import * as React from 'react';
import {ObjectFieldTemplateProps} from 'react-jsonschema-form';
import Grid, {GridSize} from '@material-ui/core/Grid';

/**
 * This is a rendered that uses the <Grid> element from material-ui
 */

export interface RowDefinition {
    [K: string]: {
        xs?: GridSize;
        md?: GridSize;
        lg?: GridSize;
        sm?: GridSize;
        xl?: GridSize;
        doShow?: (formData: any) => boolean;
        onClick?: (event:any) => any;
    }
}

export function allMd6(data: any) {
    const toRet = {};
    Object.keys(data).forEach(key => {
        toRet[key] = {md: 6}
    });
    console.log(toRet);
    return toRet;
}

const findComponent = (props: ObjectFieldTemplateProps, name: string) => {
    return props.properties.find(ele => ele.name === name);
};

const renderRow = (props: ObjectFieldTemplateProps, rowDefinition: RowDefinition, idx: number) => {
    return (<Grid container spacing={16} key={idx}>
        {
            Object.keys(rowDefinition).map((name, cellIdx) => {
                const id = `${idx}_${cellIdx}`;
                const rd = rowDefinition[name];
                if (rd.doShow && !rd.doShow(props.formData)) {
                    return (<div key={id}/>);
                }
                const {xs, md, lg, sm, xl} = rd;
                const compo = findComponent(props, name);
                if (!compo) {
                    return (<div key={id}/>);
                }
                
                
                return (
                    <Grid item key={id} xs={xs} sm={sm} md={md} lg={lg} xl={xl} onClick={rd.onClick} >
                        {compo.content}
                    </Grid>
                )
            })
        }
    </Grid>)
};

export default (props: ObjectFieldTemplateProps) => {
    return (
        <Grid container spacing={16}>
            {props.uiSchema['ui:layout'].map((el: RowDefinition, idx: number) => renderRow(props, el, idx))}
        </Grid>
    )
};



// WEBPACK FOOTER //
// ./src/components/schemaform/layout-renderer.tsx